import React from 'react';
import ReportTemplateItem from '../../../Domain/ReportTemplateItem';
import ButtonRow from '../../../Elements/ButtonRow';
import ErrorMessage from '../../../Elements/ErrorMessage';
import OrderDirectionsEnum from '../../../Enums/OrderDirectionsEnum';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import ReportTemplateService from '../../../Services/ReportTemplateService';
import AddNewReportWindowDescription from './AddNewReportWindowDescription';
import EditTemplateWindowDescription from './EditTemplateWindowDescription';
import RemoveTemplateFilePanel from './RemoveTemplateFilePanel';
import UploadTemplateFile from './UploadTemplateFilePanel';
import { saveAs } from 'file-saver';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import GeneralEditWizzardBase from '../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import CrudTypesEnum from '../../../Enums/CrudTypesEnum';

class DashboardAdmin extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);
    this.state = {
      reportList: [],
      selected: -1,
      selectedReport: null,
      orderBy: 'Id',
      orderDirection: OrderDirectionsEnum.Asc,
      pageNumber: 1,
      numberOfElementsOnAPage: 20,
      numberOfElementsInTheTable: 0,
      shownPanel: ShownPanelsEnum.None,
      searchItem: {},
    };
    ReportTemplateItem.removeTemplateFunction = this.removeTemplateFileFunction.bind(this);
    ReportTemplateItem.editTemplateFileFunction = this.editTemplateFileFunction.bind(this);
    ReportTemplateItem.addNewTemplateFunction = this.addTemplateFileFunction.bind(this);
    ReportTemplateItem.clickOnTemplateName = this.clickOnTemplateName.bind(this);
  }

  clickOnTemplateName(id, item) {
    ReportTemplateService.getReportTemplateFile(id)
      .then((result) => {
        const byteCharacters = atob(result);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        saveAs(
          new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }),
          item.TemplateName
        );
        this.refresh();
      })
      .catch((error) => {
        ErrorMessage.SetErrorMessage('DA62');
      });
  }

  removeTemplateFileFunction(id, item, itemList) {
    this.setState({
      selectedReport: item,
      shownPanel: ShownPanelsEnum.Remove,
    });
  }

  editTemplateFileFunction(id, item, itemList) {
    this.setState({
      selectedReport: item,
      shownPanel: ShownPanelsEnum.EditItem,
    });
  }

  addTemplateFileFunction(id, item, itemList) {
    this.setState({
      selectedReport: item,
      shownPanel: ShownPanelsEnum.FileUpload,
    });
  }

  refresh() {
    this.setState({ searchItem: { ...this.state.searchItem } });
  }

  editPanelOnClose(refresh) {
    this.setState({ shownPanel: ShownPanelsEnum.None });
    if (refresh) {
      this.refresh();
    }
  }

  showPanel(panelId) {
    if (panelId === ShownPanelsEnum.Refresh) {
      panelId = ShownPanelsEnum.None;
      this.refresh();
    }
    panelId = panelId === this.state.shownPanel ? ShownPanelsEnum.None : panelId;
    this.setState({ shownPanel: panelId });
  }

  renderOnePanel(panelId, content) {
    return this.state.shownPanel === panelId ? content : null;
  }

  clickOnCancel() {
    this.setState({ shownPanel: ShownPanelsEnum.None });
  }

  clickOnOk() {
    this.setState({ shownPanel: ShownPanelsEnum.None });
    this.refresh();
  }

  renderPanels() {
    return (
      <div>
        {this.renderOnePanel(ShownPanelsEnum.Search, <div className='bg-white border rounded'>Search</div>)}
        {this.renderOnePanel(
          ShownPanelsEnum.AddNewItem,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Create}
            clickOnCancel={() => this.clickOnCancel()}
            clickOnSave={() => this.clickOnOk()}
            windowDescription={AddNewReportWindowDescription}
            errorCode='DASH-RPT-ADD'
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.EditItem,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={this.state.selectedReport}
            clickOnCancel={() => this.clickOnCancel()}
            clickOnSave={() => this.clickOnOk()}
            windowDescription={EditTemplateWindowDescription}
            errorCode='DASH-RPT-EDIT'
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.Remove,
          <RemoveTemplateFilePanel
            reportItem={this.state.selectedReport}
            clickOnCancel={() => this.clickOnCancel()}
            clickOnOk={() => this.clickOnOk()}
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.FileUpload,
          <UploadTemplateFile
            reportItem={this.state.selectedReport}
            clickOnCancel={() => this.clickOnCancel()}
            clickOnOk={() => this.clickOnOk()}
          />
        )}
      </div>
    );
  }

  renderButtonsAndPanels() {
    return (
      <>
        <ButtonRow
          labels={['Create']}
          keys={[ShownPanelsEnum.AddNewItem]}
          icons={['fa-solid fa-plus-circle']}
          roles={['Developer']}
          value={this.state.shownPanel}
          onClick={this.showPanel.bind(this)}
        />
        {this.renderPanels()}
      </>
    );
  }

  render() {
    return (
      <div className='contentwrapper'>
        {this.renderButtonsAndPanels()}
        <TabOfDataTable
          type={ReportTemplateItem}
          shownPanel={this.state.shownPanel}
          serviceFunction={ReportTemplateService.GetReportTemplateList}
          convertDBItemsFunction={ReportTemplateService.ConvertDBReportTemplate}
          searchItem={this.state.searchItem}
          orderDirection={this.state.orderDirection}
          showSearchStrip={true}
          errorCode='DA211'
        />
      </div>
    );
  }
}

export default DashboardAdmin;
